module.exports = __webpack_public_path__ + "static/img/200154.b5bbd6b5.png";